import React from "react"

function AppIcon({children, className}: {children: React.ReactNode, className?: string}) {
  return <div className={`bg-gray-200 rounded-lg p-4 ${className}`}>{children}</div>
}

export default AppIcon